export default __webpack_public_path__ + "static/media/13.cde4f363.jpg";